import { gotoProduct } from 'actions/Products';
import classNames from 'classnames';
import Price from 'components/Price/index';
import AddToSubscriptionButton from 'components/Subscription/AddToSubscriptionButton/index';
import { AddToCartButton, isProductSoldOut, ProductContext } from 'product';
import React, { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import './ProductTile.scss';
function ProductTile({ product, isSubscriptionMode, variant = '', shrinkOnMobile = false, isBusiness = false, }) {
    var _a;
    const dispatch = useDispatch();
    const stock = useSelector((state) => state.products.stock);
    const productContext = useContext(ProductContext);
    const isTransparentImageCard = product.productImageType == 'transparent';
    const isFullSizeCard = product.productImageType == 'fullSize';
    const soldOut = isProductSoldOut(stock, product);
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.8,
    });
    useEffect(() => {
        if (inView) {
            dispatch({ type: 'VIEW_ITEM', payload: { product, productContext } });
        }
    }, [inView]);
    const handleClick = (event) => {
        if (isBusiness)
            return;
        const target = event.target;
        const tag = target === null || target === void 0 ? void 0 : target.tagName;
        if (tag !== 'INPUT' && tag !== 'BUTTON') {
            dispatch(gotoProduct(product, productContext));
        }
    };
    const handleKeyPress = (event) => {
        if (isBusiness)
            return;
        const target = event.target;
        const tag = target === null || target === void 0 ? void 0 : target.tagName;
        if (event.key === 'Enter' && tag !== 'BUTTON' && tag !== 'INPUT') {
            dispatch(gotoProduct(product, productContext));
        }
    };
    const button = isSubscriptionMode && !soldOut ? (React.createElement(React.Fragment, null,
        React.createElement(Price, { className: "product-tile__price", amount: product.price }),
        React.createElement(AddToSubscriptionButton, { product: product, style: "new-style" }))) : (React.createElement(AddToCartButton, { isBusiness: isBusiness, product: product, shrinkOnMobile: shrinkOnMobile, soldOut: soldOut }));
    const tileClasses = classNames({
        'product-tile': true,
        'product-tile--full-size': isFullSizeCard,
        'product-tile--artisan': product.isArtisanProduct,
        'product-tile--shrink-on-mobile': shrinkOnMobile,
        [`product-tile--${variant}`]: variant.length > 0 && !product.isArtisanProduct,
        'product-tile--business': isBusiness,
    });
    const imageClasses = classNames({
        'product-tile__aspect-ratio-wrapper__image': true,
        'product-tile__aspect-ratio-wrapper__image--full-size': isFullSizeCard,
        'product-tile__aspect-ratio-wrapper__image--transparent': isTransparentImageCard,
        'product-tile__aspect-ratio-wrapper__image--soldOut': soldOut,
    });
    const topBannerClasses = classNames({
        'product-tile__aspect-ratio-wrapper__top-banner': true,
        'product-tile__aspect-ratio-wrapper__top-banner--full-size': isFullSizeCard,
        'product-tile__aspect-ratio-wrapper__top-banner--artisan': product.isArtisanProduct,
    });
    let imageElement;
    // For some reason the webpack compiler doesn't understand that
    // product is implicitly cast here, so this more manual check is used
    // in place of if (isTransparentImageCard) {}.
    if ('fullSize' in product.navigationImage) {
        // Temporary if-block until cache updates to avoid breaking
        // full size product cards in the transition to webp transformers
        if (product.navigationImage.webp_600x994) {
            imageElement = (React.createElement("picture", null,
                React.createElement("source", { type: "image/webp", srcSet: `
                    ${product.navigationImage.webp_300x497} 1x,
                    ${product.navigationImage.webp_600x994} 2x
                    ` }),
                React.createElement("img", { loading: "lazy", className: imageClasses, src: product.navigationImage.fullSize, alt: product.title })));
        }
        else {
            imageElement = (React.createElement("img", { loading: "lazy", className: imageClasses, src: product.navigationImage.fullSize, alt: product.title }));
        }
    }
    else {
        imageElement = (React.createElement("picture", null,
            React.createElement("source", { type: "image/webp", srcSet: `
                        ${product.navigationImage.webp_400x400} 400w,
                        ${product.navigationImage.webp_600x600} 600w,
                        ${product.navigationImage.webp_800x800} 800w
                    `, sizes: "(max-width: 767px) 200px, 400px" }),
            React.createElement("img", { loading: "lazy", className: imageClasses, src: product.navigationImage.large, alt: product.title })));
    }
    return (React.createElement("div", { ref: ref, className: tileClasses, tabIndex: 0, onClick: handleClick, onKeyPress: handleKeyPress },
        React.createElement("div", { className: "product-tile__aspect-ratio-wrapper" },
            React.createElement("div", { className: topBannerClasses },
                React.createElement("div", { className: "product-tile__aspect-ratio-wrapper__top-banner__text-wrapper" },
                    React.createElement("span", { className: "product-tile__aspect-ratio-wrapper__top-banner__text-wrapper__producer" }, product.producer ? product.producer.name : product.vendor),
                    React.createElement("h3", { className: "product-tile__aspect-ratio-wrapper__top-banner__text-wrapper__title" }, product.title)),
                ((_a = product.badge) === null || _a === void 0 ? void 0 : _a.image) && (React.createElement("img", { className: "product-tile__aspect-ratio-wrapper__top-banner__badge", src: product.badge.image, alt: product.badge.name }))),
            imageElement,
            React.createElement("div", { className: "product-tile__aspect-ratio-wrapper__bottom" },
                React.createElement("div", { className: "product-tile__aspect-ratio-wrapper__bottom__filter-tags" }, product.filterTags.map((tag) => tag.image && (React.createElement("img", { className: "product-tile__aspect-ratio-wrapper__bottom__filter-tags__image", src: tag.image, alt: tag.name, key: tag.name + tag.image })))),
                React.createElement("div", { className: "product_tile__aspect-ratio-wrapper__bottom__button-container" }, button)))));
}
export default ProductTile;
